<div class="visits-container">

  @if (visits.length > 0) {
    <div class="visits-header">
      <div class="header-left">
        <span class="header-icon">
          <i class="fa fa-calendar-check-o"></i>
        </span>
        <div>
          <h3 class="header-title">Prospective Customer Visits</h3>
          <p class="header-sub">Visit history carried over from prospective customer record</p>
        </div>
      </div>
      <span class="visit-count-badge">
        {{ visits.length }} Visit{{ visits.length !== 1 ? 's' : '' }}
      </span>
    </div>
  }

  @if (isLoadingVisits) {
    <div class="state-box">
      <div class="spinner"></div>
      <p>Loading visit history...</p>
    </div>
  }

  @if (!isLoadingVisits && visitsError) {
    <div class="state-box error">
      <i class="fa fa-exclamation-circle error-icon"></i>
      <p class="error-title">{{ visitsError }}</p>
    </div>
  }

  @if (!isLoadingVisits && !visitsError && visits.length > 0) {
    <div class="table-wrapper">
      <table class="visits-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Visit Date</th>
            <th>Visited By</th>
            <th>Visit Mode</th>
            <th>Comments</th>
            <th>Next Follow-up</th>
          </tr>
        </thead>
        <tbody>
          @for (visit of visits; track visit.id; let i = $index) {
            <tr class="visit-row">
              <td class="index-cell">{{ i + 1 }}</td>
              <td class="date-cell">
                <span class="date-badge">
                  <i class="fa fa-calendar"></i>
                  {{ visit.visitDate | date: 'dd MMM yyyy' }}
                </span>
              </td>
              <td class="person-cell">
                <span class="person-tag">
                  <i class="fa fa-user-o"></i>
                  {{ visit.visitedByName || '—' }}
                </span>
              </td>
              <td class="mode-cell">
                @if (visit.visitMode) {
                  <span class="mode-pill" [attr.data-mode]="visit.visitMode">
                    <i class="fa"
                      [class.fa-handshake-o]="visit.visitMode === 'In-person'"
                      [class.fa-video-camera]="visit.visitMode === 'Video Call'"
                      [class.fa-phone]="visit.visitMode === 'Phone'"
                      [class.fa-envelope-o]="visit.visitMode === 'Email'"
                      [class.fa-comments-o]="!['In-person','Video Call','Phone','Email'].includes(visit.visitMode)">
                    </i>
                    {{ visit.visitMode }}
                  </span>
                } @else {
                  <span class="empty-val">—</span>
                }
              </td>
              <td class="comments-cell">
                <span [title]="visit.comments">{{ visit.comments || '—' }}</span>
              </td>
              <td class="followup-cell">
                @if (visit.nextFollowUpDate) {
                  <span class="followup-badge">
                    <i class="fa fa-clock-o"></i>
                    {{ visit.nextFollowUpDate | date: 'dd MMM yyyy' }}
                  </span>
                } @else {
                  <span class="empty-val">—</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="converted-notice">
      <i class="fa fa-info-circle"></i>
      <span>These visits were recorded when this account was a prospective customer.</span>
    </div>
  }

  <!-- @if (canEditTabs) {
    <nz-divider style="font-weight: bold;" nzText="Add New Visit" nzOrientation="left"></nz-divider>
  } -->

  @if (formGroup && canEditTabs) {
    <form nz-form [formGroup]="formGroup" (ngSubmit)="create()">
      <div nz-row nzGutter="16">

        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzRequired>Visit Date</nz-form-label>
            <nz-form-control>
              <nz-date-picker formControlName="visitDate"
                nzPlaceHolder="Select date" style="width: 100%">
              </nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzRequired>Visited By</nz-form-label>
            <nz-form-control>
              <span style="font-weight: 500;">{{ currentUser?.userName }}</span>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label nzRequired>Visit Mode</nz-form-label>
            <nz-form-control>
              <input nz-input formControlName="visitMode"
                placeholder="Enter Visit Mode" maxlength="50">
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="6">
          <nz-form-item>
            <nz-form-label>Next Follow-Up Date</nz-form-label>
            <nz-form-control>
              <nz-date-picker formControlName="nextFollowUpDate"
                nzPlaceHolder="Select date"
                [nzDisabledDate]="disabledNextFollowUpDate"
                [nzDisabled]="!formGroup.get('visitDate')?.value"
                style="width: 100%">
              </nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="16">
          <nz-form-item>
            <nz-form-label>Comments</nz-form-label>
            <nz-form-control>
              <textarea nz-input formControlName="comments"
                placeholder="Enter discussion notes"
                [nzAutosize]="{ minRows: 2, maxRows: 4 }">
              </textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label>Attachments</nz-form-label>
            <nz-form-control>
              <nz-upload
                [(nzFileList)]="attachmentList"
                [nzBeforeUpload]="beforeUpload"
                nzListType="text">
                <button nz-button type="button">
                  <i nz-icon nzType="upload"></i> Upload File
                </button>
              </nz-upload>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col nzSpan="24">
          <button nz-button nzType="primary"
            [disabled]="formGroup.invalid || !canEditTabs" type="submit">
            <i nz-icon nzType="plus"></i> Add Visit
          </button>
        </div>

      </div>
    </form>
  }

  <!-- @if (customerVisits.length === 0) {
    <div class="state-box"
      style="display: flex; flex-direction: column; align-items: center;
             justify-content: center; padding: 40px 16px;
             border: 1px dashed #d9d9d9; border-radius: 8px;
             background: #fafafa; text-align: center;">
      <i class="fa fa-calendar-o" style="font-size: 36px; color: #bbb;"></i>
      <p style="margin-top: 12px; font-size: 15px; color: #999; font-weight: 500;">
        No visit history found
      </p>
      <p style="margin: 4px 0 0; font-size: 13px; color: #bbb;">
        No visits have been recorded for this customer yet.
      </p>
    </div>
  } -->

  @if (customerVisits.length > 0) {
    <nz-divider style="font-weight: bold;" nzText="Visit History" nzOrientation="left"></nz-divider>
    <nz-table #customerVisitTable [nzData]="customerVisits"
      nzSize="middle" [nzShowPagination]="false">
      <thead>
        <tr>
          <th>Visit Date</th>
          <th>Visited By</th>
          <th>Visit Mode</th>
          <th>Next Follow-Up</th>
          <th>Comments</th>
          <th>Attachments</th>
          @if (canEditTabs) {
            <th>Actions</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (visit of customerVisitTable.data; track visit.id) {
          <tr>

            <!-- VIEW MODE -->
            @if (editId !== visit.id) {
              <td>{{ visit.visitDate | date: 'dd MMM yyyy' }}</td>
              <td>{{ visit.visitedByName }}</td>
              <td>
                <nz-tag>
                  {{ visit.visitMode }}
                </nz-tag>
              </td>
              <td>{{ visit.nextFollowUpDate ? (visit.nextFollowUpDate | date: 'dd MMM yyyy') : '—' }}</td>
              <td>{{ visit.comments || '—' }}</td>
              <td>
                @if (visit.attachments?.length > 0) {
                  @for (att of visit.attachments; track att.id) {
                    <div>
                      <a (click)="openPreview(att)" style="cursor: pointer; color: #1890ff;">
                        <i nz-icon nzType="file-pdf" nzTheme="twotone" style="margin-right: 4px;"></i>
                        {{ att.name }}
                      </a>
                    </div>
                  }
                } @else {
                  <span style="color: var(--color-text-secondary);">—</span>
                }
              </td>
              @if (canEditTabs) {
                <td>
                  <button nz-button nzType="link" nzSize="small"
                    nz-tooltip nzTooltipTitle="Edit"
                    (click)="startEdit(visit)">
                    <i nz-icon nzType="edit" style="color: #1890ff; font-size: 16px;"></i>
                  </button>
                  <button nz-button nzType="link" nzSize="small"
                    nz-tooltip nzTooltipTitle="Delete"
                    nz-popconfirm nzPopconfirmTitle="Are you sure to delete?"
                    (nzOnConfirm)="delete(visit.id)">
                    <i nz-icon nzType="delete" style="color:#ff4d4f;font-size:16px;"></i>
                  </button>
                </td>
              }
            }

            <!-- EDIT MODE -->
            @if (editId === visit.id) {
              <td>
                <nz-date-picker [(ngModel)]="editForm.visitDate" style="width: 100%">
                </nz-date-picker>
              </td>
              <td>
                <span>{{ editForm.visitedByName }}</span>
              </td>
              <td>
                <input nz-input [(ngModel)]="editForm.visitMode" maxlength="50" />
              </td>
              <td>
                <nz-date-picker
                  [(ngModel)]="editForm.nextFollowUpDate"
                  [nzDisabledDate]="disabledNextFollowUpDateEdit"
                  [nzDisabled]="!editForm.visitDate"
                  style="width: 100%">
                </nz-date-picker>
              </td>
              <td>
                <textarea nz-input [(ngModel)]="editForm.comments"
                  [nzAutosize]="{ minRows: 1, maxRows: 3 }">
                </textarea>
              </td>
              <td>
                @if (visit.attachments?.length > 0) {
                  @for (att of visit.attachments; track att.id) {
                    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
                      <a (click)="openPreview(att)" style="cursor: pointer; color: #1890ff;">
                        <i nz-icon nzType="file-pdf" nzTheme="twotone" style="margin-right: 4px;"></i>
                        {{ att.name }}
                      </a>
                      @if (canEditTabs) {
                        <span nz-popconfirm nzPopconfirmTitle="Delete this attachment?"
                          (nzOnConfirm)="deleteAttachment(att, visit.id)"
                          style="cursor: pointer; color: #c90909;">
                          <i nz-icon nzType="delete"></i>
                        </span>
                      }
                    </div>
                  }
                } @else {
                  <span style="color: var(--color-text-secondary);">—</span>
                }
              </td>
              @if (canEditTabs) {
                <td style="white-space: nowrap; vertical-align: middle;">
                  <span style="display: inline-flex; align-items: center; gap: 8px; flex-wrap: nowrap;">
                    <button nz-button nzType="primary" nzSize="small"
                      nz-tooltip nzTooltipTitle="Save"
                      (click)="saveEdit(visit.id)"
                      style="border-radius: 4px; width: 26px; height: 26px; padding: 0; display: inline-flex; align-items: center; justify-content: center;">
                      <i nz-icon nzType="check" style="font-size: 13px;"></i>
                    </button>
                    <button nz-button nzType="default" nzSize="small"
                      nz-tooltip nzTooltipTitle="Cancel"
                      (click)="cancelEdit()"
                      style="border-radius: 4px; width: 26px; height: 26px; padding: 0; display: inline-flex; align-items: center; justify-content: center;">
                      <i nz-icon nzType="stop" style="color: #ff4d4f; font-size: 13px;"></i>
                    </button>
                    <nz-upload [nzBeforeUpload]="beforeUploadEdit" [nzShowUploadList]="false">
                      <button nz-button nzType="link" nzSize="small" type="button"
                        nz-tooltip nzTooltipTitle="Upload Attachment">
                        <i nz-icon nzType="upload" style="color: #1890ff; font-size: 13px;"></i>
                      </button>
                    </nz-upload>
                  </span>
                </td>
              }
            }

          </tr>
        }
      </tbody>
    </nz-table>
  }

</div>
